import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import api from "@/api";
import subjects from "@/utils/subjects";
import multiBarChart from "@/components/chart/multiBarChart.vue";
export default {
  name: "ScoreView",
  components: [multiBarChart],
  data() {
    return {
      // 此处没有与后端同步，有机会改成同步
      menus: [{
        "name": "初试",
        "sub": [{
          "name": "代码计算",
          "desc": "",
          "subjects": [{
            "name": "代码计算",
            "desc": "",
            "tags": [],
            "subject": "CodeMath"
          }, {
            "name": "跷跷板",
            "desc": "",
            "tags": [],
            "subject": "Seesaw"
          }, {
            "name": "价值换算",
            "desc": "",
            "tags": [],
            "subject": "PriceCalculate"
          }, {
            "name": "汉诺塔推理",
            "desc": "",
            "tags": [],
            "subject": "HanoiTowerInference"
          }]
        }, {
          "name": "逻辑推理",
          "desc": "",
          "subjects": [{
            "name": "图形推理",
            "desc": "",
            "tags": [],
            "subject": "LogicalReasoning"
          }, {
            "name": "平面图形推理",
            "desc": "",
            "tags": [],
            "subject": "LogicalReasoning2D"
          }, {
            "name": "文字推理",
            "desc": "",
            "tags": [],
            "subject": "TextLogicalReasoning"
          }, {
            "name": "黑盒光路推理",
            "desc": "",
            "tags": [],
            "subject": "OpticalPathInference"
          }, {
            "name": "图形匹配",
            "desc": "",
            "tags": [],
            "subject": "GraphMatch"
          }, {
            "name": "矩阵旋转",
            "desc": "",
            "tags": [],
            "subject": "RotateMatrix"
          }, {
            "name": "彩色矩阵旋转",
            "desc": "",
            "tags": [],
            "subject": "ColorRotateMatrix"
          }, {
            "name": "平面变换推理",
            "desc": "",
            "tags": [],
            "subject": "LogicalTransformer2D"
          }, {
            "name": "扇形变换",
            "desc": "",
            "tags": [],
            "subject": "LogicalTransformerSector"
          }, {
            "name": "扇形变换Plus",
            "desc": "",
            "tags": [],
            "subject": "LogicalTransformerSectorPlus"
          }, {
            "name": "九宫镜像推断",
            "desc": "",
            "tags": [],
            "subject": "NineGridMirrorInference"
          }]
        }, {
          "name": "立体思维",
          "desc": "",
          "subjects": [{
            "name": "几何旋转",
            "desc": "",
            "tags": [],
            "subject": "BlockRotate"
          }, {
            "name": "立体补墙",
            "desc": "",
            "tags": [],
            "subject": "FillWall"
          }, {
            "name": "立方体补集",
            "desc": "",
            "tags": [],
            "subject": "CubeComplement"
          }, {
            "name": "随机森林",
            "desc": "",
            "tags": [],
            "subject": "RandomForest"
          }, {
            "name": "地面视角",
            "desc": "",
            "tags": [],
            "subject": "GroundPerspective"
          }, {
            "name": "立体展开图",
            "desc": "",
            "tags": [],
            "subject": "Unfolding3D"
          }, {
            "name": "立体投影",
            "desc": "",
            "tags": [],
            "subject": "StereoProjection"
          }, {
            "name": "彩色高度投影",
            "desc": "",
            "tags": [],
            "subject": "ColorHeightProjection"
          }, {
            "name": "机械臂水瓶姿态",
            "desc": "",
            "tags": [],
            "subject": "MechanicalArmPose"
          }, {
            "name": "机械臂水瓶姿态训练",
            "desc": "",
            "tags": [],
            "subject": "MechanicalArmPosePractice"
          }]
        }, {
          "name": "工作记忆",
          "desc": "",
          "subjects": [{
            "name": "舒尔特方格闪图",
            "desc": "",
            "tags": [],
            "subject": "FlashDiamond"
          }, {
            "name": "图形变换",
            "desc": "",
            "tags": [],
            "subject": "ImageTransform"
          }, {
            "name": "打地鼠",
            "desc": "",
            "tags": [],
            "subject": "WhackAMole"
          }, {
            "name": "快速记忆",
            "desc": "",
            "tags": [],
            "subject": "FastMemory"
          }, {
            "name": "黑白子",
            "desc": "",
            "tags": [],
            "subject": "BlackWhiteDot"
          }, {
            "name": "方格闪烁",
            "desc": "",
            "tags": [],
            "subject": "FlashingRect"
          }, {
            "name": "序列回溯",
            "desc": "",
            "tags": [],
            "subject": "SequenceBacktracking"
          }, {
            "name": "彩色方格记忆",
            "desc": "",
            "tags": [],
            "subject": "ColorGridMemory"
          }, {
            "name": "图形记忆力",
            "desc": "",
            "tags": [],
            "subject": "ImageSequenceMemory"
          }]
        }]
      }, {
        "name": "复试",
        "sub": [{
          "name": "E808A",
          "desc": "找相同图形，考察图形处理能力，记忆力",
          "subjects": [{
            "name": "E808A1",
            "desc": "",
            "tags": [],
            "subject": "E808APlus"
          }, {
            "name": "E808A2",
            "desc": "",
            "tags": [],
            "subject": "E808EPlus"
          }, {
            "name": "E808A1消失",
            "desc": "",
            "tags": [],
            "subject": "E808A"
          }, {
            "name": "E808A2消失",
            "desc": "",
            "tags": [],
            "subject": "E808E"
          }, {
            "name": "E808A快速量表",
            "desc": "",
            "tags": [],
            "subject": "QuickScale"
          }]
        }, {
          "name": "E808B",
          "desc": "根据规则判断边/符号是否相同，考察逻辑处理能力，记忆力",
          "subjects": [{
            "name": "E808B1",
            "desc": "",
            "tags": [],
            "subject": "E808B"
          }, {
            "name": "E808B2",
            "desc": "",
            "tags": [],
            "subject": "E808B2"
          }, {
            "name": "E808B3",
            "desc": "",
            "tags": [],
            "subject": "E808C"
          }]
        }, {
          "name": "E808C",
          "desc": "根据规则进行三角形分类及纠错，考察逻辑处理能力",
          "subjects": [{
            "name": "E808C1 完整三角形分类",
            "desc": "",
            "tags": [],
            "subject": "E808B3"
          }, {
            "name": "E808C2 缺失三角形分类",
            "desc": "",
            "tags": [],
            "subject": "E808B4"
          }, {
            "name": "E808C3 三角形纠错",
            "desc": "",
            "tags": [],
            "subject": "E808D2"
          }]
        }, {
          "name": "E808D",
          "desc": "三角形计算，考察逻辑能力、计算能力",
          "subjects": [{
            "name": "E808D1 三角形计算",
            "desc": "",
            "tags": [],
            "subject": "E808D"
          }]
        }, {
          "name": "摩斯密码",
          "desc": "",
          "subjects": [{
            "name": "摩斯密码(3位)",
            "desc": "",
            "tags": [],
            "subject": "Moss"
          }, {
            "name": "摩斯密码(4位)",
            "desc": "",
            "tags": [],
            "subject": "HarderMoss"
          }, {
            "name": "摩斯密码(5位)",
            "desc": "",
            "tags": [],
            "subject": "Moss5"
          }, {
            "name": "摩斯密码(3位)消失",
            "desc": "",
            "tags": [],
            "subject": "MossCopy"
          }, {
            "name": "摩斯密码(4位)消失",
            "desc": "",
            "tags": [],
            "subject": "MossMissing4"
          }, {
            "name": "摩斯密码(5位)消失",
            "desc": "",
            "tags": [],
            "subject": "MossMissing5"
          }]
        }, {
          "name": "逻辑推理",
          "desc": "往届复试中的逻辑推理题目",
          "subjects": [{
            "name": "神经网络",
            "desc": "",
            "tags": [],
            "subject": "NeuralNetwork"
          }, {
            "name": "汉诺塔推理",
            "desc": "",
            "tags": [],
            "subject": "HanoiTowerInference"
          }]
        }, {
          "name": "立体思维",
          "desc": "往届复试中的立体思维题目",
          "subjects": [{
            "name": "3D切面(练习模式)",
            "desc": "",
            "tags": [],
            "subject": "StereoscopicSection"
          }, {
            "name": "3D切面(考试模式)",
            "desc": "",
            "tags": [],
            "subject": "StereoscopicSectionExam"
          }]
        }, {
          "name": "工作记忆",
          "desc": "往届复试中的工作记忆题目",
          "subjects": [{
            "name": "随机骰子",
            "desc": "",
            "tags": [],
            "subject": "RandomDice"
          }, {
            "name": "彩色方格记忆",
            "desc": "",
            "tags": [],
            "subject": "ColorGridMemory"
          }, {
            "name": "图形记忆力",
            "desc": "",
            "tags": [],
            "subject": "ImageSequenceMemory"
          }]
        }]
      }, {
        "name": "能力拓展",
        "sub": [{
          "name": "F-3D量表",
          "desc": "",
          "subjects": [{
            "name": "F3D量表A",
            "desc": "",
            "tags": [],
            "subject": "F3DScaleA"
          }, {
            "name": "F3D量表B",
            "desc": "",
            "tags": [],
            "subject": "F3DScaleB"
          }, {
            "name": "F3D量表C",
            "desc": "",
            "tags": [],
            "subject": "F3DScaleC"
          }]
        }, {
          "name": "八卦图谱",
          "desc": "",
          "subjects": [{
            "name": "八卦图A",
            "desc": "",
            "tags": [],
            "subject": "TaiChiA"
          }, {
            "name": "八卦图B",
            "desc": "",
            "tags": [],
            "subject": "TaiChiB"
          }]
        }]
      }],
      multiData: [],
      infoMap: subjects.infoMap,
      desc: ''
    };
  },
  watch: {},
  methods: {
    async onTabClick(desc, subs) {
      this.desc = desc;
      let subjectStr = subs.map(item => item.subject).join(',');
      const res = await api.getUserExamstatistic({
        subjectStr
      });
      console.log(res && Array.isArray(res));
      if (res && Array.isArray(res)) {
        this.multiData = res.map(item => {
          let rank = '';
          const rightRank = Number(item.rightRank) + 1;
          if (rightRank && item.rankUserCnt) {
            const rankRatio = rightRank / item.rankUserCnt;
            if (rankRatio <= 0.1) rank = 5;else if (rankRatio <= 0.3) rank = 4;else if (rankRatio <= 0.7) rank = 3;else if (rankRatio <= 1) rank = 2;
          }
          const info = this.infoMap[item.subjectName];
          return {
            ...item,
            rank,
            ...info
          };
        });
      }
    }
  },
  mounted() {
    const initData = this.menus[0].sub[0];
    this.onTabClick(initData.desc, initData.subjects);
  }
};